import { AuthStore } from '../auth/auth';
import { ModalStore } from '../modal/modal';

export type Environment = {
  appNameSpace: string;
  authUrl: string;
  restApi: string;
  production?: boolean;
  sentryDSN?: string;
  xstateDebug?: boolean;
  patientAppUrl?: string;
};

export class RootStore {
  authStore: AuthStore;
  modalStore: ModalStore;
  environment: Environment;

  constructor(environment: Environment) {
    this.environment = environment;
    this.modalStore = new ModalStore();
    this.authStore = new AuthStore(this);
  }

  static createRootStore = (environment: Environment) => new RootStore(environment);
}
